export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5473.3fba2073.jpg";